import { useI18n } from "../../lib/i18n";
import { Infinity as InfinityIcon, Crown } from "lucide-react";

export const AnalysisQuota = ({ quota }) => {
  const { t } = useI18n();
  if (!quota) return null;

  if (quota.plan === "OWNER") {
    return (
      <div className="flex items-center gap-2.5 px-4 py-2.5 border border-warn/30 bg-warn/[0.04]" data-testid="quota-owner">
        <Crown className="h-4 w-4 text-warn" strokeWidth={1.5} />
        <span className="font-mono text-sm text-warn">{t("quota_owner")}</span>
      </div>
    );
  }
  if (quota.unlimited) {
    return (
      <div className="flex items-center gap-2.5 px-4 py-2.5 border border-bull/30 bg-bull/[0.04]" data-testid="quota-pro">
        <InfinityIcon className="h-4 w-4 text-bull" strokeWidth={1.5} />
        <span className="font-mono text-sm text-bull">{t("quota_unlimited")}</span>
      </div>
    );
  }
  const remaining = quota.remaining ?? 0;
  const limit = quota.limit;
  const used = quota.used;
  const pct = limit ? Math.min(100, (used / limit) * 100) : 0;

  // FREE plan : show remaining; TRADER : show used/limit with bar
  if (quota.plan === "FREE") {
    const color = remaining <= 1 ? "text-bear" : remaining <= 2 ? "text-warn" : "text-bull";
    return (
      <div className="px-4 py-2.5 border border-white/10 bg-white/[0.02] min-w-[220px]" data-testid="quota-free">
        <div className="flex items-baseline justify-between gap-3">
          <span className={`font-mono text-sm ${color}`}>{remaining} {t("quota_remaining")}</span>
        </div>
        <div className="mt-2 h-1 bg-white/5 overflow-hidden">
          <div className={`h-full ${pct >= 100 ? "bg-bear" : pct >= 80 ? "bg-warn" : "bg-bull"}`} style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }
  // TRADER
  const color = pct >= 80 ? "text-warn" : "text-bull";
  return (
    <div className="px-4 py-2.5 border border-white/10 bg-white/[0.02] min-w-[220px]" data-testid="quota-trader">
      <div className="flex items-baseline justify-between gap-3">
        <span className="font-mono text-[10px] tracking-[0.18em] uppercase text-neutral-500">{t("plan_TRADER")}</span>
        <span className={`font-mono text-sm ${color}`}>{used} / {limit}</span>
      </div>
      <div className="mt-2 h-1 bg-white/5 overflow-hidden">
        <div className={`h-full ${pct >= 100 ? "bg-bear" : pct >= 80 ? "bg-warn" : "bg-bull"}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
